import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBodySmaller from 'components/TextBodySmaller'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { useTheme } from 'modules/styles'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'

const messages = defineMessages({
  heading: {
    id: 'CheckExerciseFormSlug.CommonMistakes.heading',
    defaultMessage: 'Common Form Mistakes to Avoid'
  },
  intro: {
    id: 'CheckExerciseFormSlug.CommonMistakes.intro',
    defaultMessage: 'Even experienced athletes make form mistakes during {exerciseName}. Our AI analyzes your technique to help you:'
  },
  point1: {
    id: 'CheckExerciseFormSlug.CommonMistakes.point1',
    defaultMessage: 'Identify poor posture and alignment issues'
  },
  point2: {
    id: 'CheckExerciseFormSlug.CommonMistakes.point2',
    defaultMessage: 'Detect incorrect movement tempo and rhythm'
  },
  point3: {
    id: 'CheckExerciseFormSlug.CommonMistakes.point3',
    defaultMessage: 'Spot coordination problems that reduce effectiveness'
  },
  point4: {
    id: 'CheckExerciseFormSlug.CommonMistakes.point4',
    defaultMessage: 'Prevent injuries from improper technique'
  }
})

export function CommonMistakes ({ exerciseName, content }) {
  const intl = useIntl()
  const theme = useTheme()

  // Use database content if available, otherwise fallback to template
  const hasContent = !!content
  const heading = hasContent
    ? `${exerciseName} Form Checking Tips`
    : formatMessageIntlUtil(intl, messages.heading)

  console.log('[CommonMistakes] exerciseName:', exerciseName)
  console.log('[CommonMistakes] hasContent:', hasContent)
  console.log('[CommonMistakes] content:', content)

  return (
    <Block bgc='backgroundContent'>
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View mb={3}>
          <TextTitleCompressedHeavy style={{ textAlign: 'center' }}>
            {heading}
          </TextTitleCompressedHeavy>
        </View>

        {hasContent
          ? (
            <div
              style={{ color: theme.colors.paragraph }}
              dangerouslySetInnerHTML={{
                __html: markdownToHtmlStringUtil(content)
              }}
            />
            )
          : (
            <>
              <View mb={2}>
                <TextBodySmaller
                  style={{
                    color: theme.colors.paragraph,
                    textAlign: 'center'
                  }}
                >
                  {formatMessageIntlUtil(intl, messages.intro, { exerciseName })}
                </TextBodySmaller>
              </View>

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem'
                }}
              >
                <View
                  row
                  ac
                  style={{ gap: '0.5rem' }}
                >
                  <View
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: theme.colors.primary,
                      flexShrink: 0
                    }}
                  />
                  <TextBodySmaller style={{ color: theme.colors.paragraph }}>
                    {formatMessageIntlUtil(intl, messages.point1)}
                  </TextBodySmaller>
                </View>

                <View
                  row
                  ac
                  style={{ gap: '0.5rem' }}
                >
                  <View
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: theme.colors.primary,
                      flexShrink: 0
                    }}
                  />
                  <TextBodySmaller style={{ color: theme.colors.paragraph }}>
                    {formatMessageIntlUtil(intl, messages.point2)}
                  </TextBodySmaller>
                </View>

                <View
                  row
                  ac
                  style={{ gap: '0.5rem' }}
                >
                  <View
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: theme.colors.primary,
                      flexShrink: 0
                    }}
                  />
                  <TextBodySmaller style={{ color: theme.colors.paragraph }}>
                    {formatMessageIntlUtil(intl, messages.point3)}
                  </TextBodySmaller>
                </View>

                <View
                  row
                  ac
                  style={{ gap: '0.5rem' }}
                >
                  <View
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: theme.colors.primary,
                      flexShrink: 0
                    }}
                  />
                  <TextBodySmaller style={{ color: theme.colors.paragraph }}>
                    {formatMessageIntlUtil(intl, messages.point4)}
                  </TextBodySmaller>
                </View>
              </View>
            </>
            )}
      </View>
    </Block>
  )
}

CommonMistakes.propTypes = {
  exerciseName: PropTypes.string.isRequired,
  content: PropTypes.string
}
